import { baseRequest } from '../utils';

export const types = {
  FETCH_NOTIFICATIONS_REQUEST: 'FETCH_NOTIFICATIONS_REQUEST',
  FETCH_NOTIFICATIONS_SUCCESS: 'FETCH_NOTIFICATIONS_SUCCESS',
  FETCH_NOTIFICATIONS_ERROR: 'FETCH_NOTIFICATIONS_ERROR',
  FETCH_UNREAD_COUNT_SUCCESS: 'FETCH_UNREAD_COUNT_SUCCESS',
  MARK_NOTIFICATION_READ_SUCCESS: 'MARK_NOTIFICATION_READ_SUCCESS',
  RECEIVE_LIVE_NOTIFICATION: 'RECEIVE_LIVE_NOTIFICATION',
  FETCH_MODAL_NOTIFICATIONS_REQUEST: 'FETCH_MODAL_NOTIFICATIONS_REQUEST',
  FETCH_MODAL_NOTIFICATIONS_SUCCESS: 'FETCH_MODAL_NOTIFICATIONS_SUCCESS',
  FETCH_MODAL_NOTIFICATIONS_ERROR: 'FETCH_MODAL_NOTIFICATIONS_ERROR',
};

const initialState = {
  items: [],
  total: 0,
  unreadCount: 0,
  loading: false,
  modalItems: [],
  modalTotal: 0,
  modalLoading: false,
};

export const fetchNotifications = ({ page = 1, docsPerPage = 50 } = {}) => {
  const success = (payload) => ({ type: types.FETCH_NOTIFICATIONS_SUCCESS, payload });
  const failure = () => ({ type: types.FETCH_NOTIFICATIONS_ERROR });

  return (dispatch) => {
    dispatch({ type: types.FETCH_NOTIFICATIONS_REQUEST });
    return baseRequest('GET', '/notification-center', null, {}, { page, docsPerPage })
      .then((response) => dispatch(success(response.data)))
      .catch(() => dispatch(failure()));
  };
};

// Backs the "View All" modal specifically, so paging through it doesn't clobber
// the bell dropdown's own items/total (fetched once, capped at 50).
export const fetchNotificationsForModal = ({ page = 1, docsPerPage = 10, sortBy = 'newest' } = {}) => {
  const success = (payload) => ({ type: types.FETCH_MODAL_NOTIFICATIONS_SUCCESS, payload });
  const failure = () => ({ type: types.FETCH_MODAL_NOTIFICATIONS_ERROR });

  return (dispatch) => {
    dispatch({ type: types.FETCH_MODAL_NOTIFICATIONS_REQUEST });
    return baseRequest('GET', '/notification-center', null, {}, { page, docsPerPage, sortBy })
      .then((response) => dispatch(success(response.data)))
      .catch(() => dispatch(failure()));
  };
};

export const fetchUnreadCount = () => {
  return (dispatch) => {
    return baseRequest('GET', '/notification-center/unread-count')
      .then((response) => dispatch({ type: types.FETCH_UNREAD_COUNT_SUCCESS, payload: response.data?.count ?? 0 }))
      .catch(() => {});
  };
};

export const markNotificationRead = (id) => {
  return (dispatch) => {
    return baseRequest('PATCH', `/notification-center/${id}/read`)
      .then(() => dispatch({ type: types.MARK_NOTIFICATION_READ_SUCCESS, payload: id }))
      .catch(() => {});
  };
};

export const receiveLiveNotification = (notification) => ({
  type: types.RECEIVE_LIVE_NOTIFICATION,
  payload: notification,
});

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true };
    case types.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.data,
        total: action.payload.meta?.total ?? action.payload.data.length,
      };
    case types.FETCH_NOTIFICATIONS_ERROR:
      return { ...state, loading: false };
    case types.FETCH_MODAL_NOTIFICATIONS_REQUEST:
      return { ...state, modalLoading: true };
    case types.FETCH_MODAL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        modalLoading: false,
        modalItems: action.payload.data,
        modalTotal: action.payload.meta?.total ?? action.payload.data.length,
      };
    case types.FETCH_MODAL_NOTIFICATIONS_ERROR:
      return { ...state, modalLoading: false };
    case types.FETCH_UNREAD_COUNT_SUCCESS:
      return { ...state, unreadCount: action.payload };
    case types.MARK_NOTIFICATION_READ_SUCCESS: {
      const wasUnread = state.items.some((item) => item.id === action.payload && item.status === 'UNREAD');

      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload ? { ...item, status: 'READ', readAt: new Date().toISOString() } : item
        ),
        unreadCount: wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount,
      };
    }
    case types.RECEIVE_LIVE_NOTIFICATION:
      return {
        ...state,
        items: [action.payload, ...state.items],
        total: state.total + 1,
        unreadCount: state.unreadCount + 1,
      };
    default:
      return state;
  }
};

export default notificationsReducer;
